import React from 'react';

export interface BadgeProps {
  variant?: 'purple' | 'green' | 'red' | 'amber' | 'blue' | 'gray';
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'purple',
  children,
  icon,
  className = '',
}) => {
  const variantStyles = {
    purple: 'bg-avn-purple-100 text-avn-purple-800',
    green: 'bg-green-100 text-green-800',
    red: 'bg-red-100 text-red-800',
    amber: 'bg-amber-100 text-amber-800',
    blue: 'bg-blue-100 text-blue-800',
    gray: 'bg-gray-100 text-gray-800',
  };

  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`}>
      {icon && icon}
      {children}
    </span>
  );
};

export default Badge;